export default __webpack_public_path__ + "static/Tengable-intro-7e6ba3d4e90ad551ff2ccbbaddc7c33e.mp4";